/**
 * Binance wBETH `UnwrapTokenV1` — the on-chain unwrap queue, deployed at
 * the SAME address (`0x79973d557CD9dd87eb61E250cc2572c990e20196`) on both
 * Ethereum and BNB.
 *
 * Entered from the token via `wBETH.requestWithdrawEth(uint256)`, which
 * burns the shares and books a request here against `msg.sender`.
 */
export const BinanceUnwrapQueueAbi = [
  {
    name: 'getUserWithdrawRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'recipient' }],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'address', name: 'recipient' },
          { type: 'uint256', name: 'wbethAmount' },
          { type: 'uint256', name: 'ethAmount' },
          { type: 'uint256', name: 'triggerTime' },
          { type: 'uint256', name: 'claimTime' },
          { type: 'bool', name: 'allocated' },
        ],
      },
    ],
  },
  {
    // Currently 864000 (10 days). Admin-settable down to
    // `MIN_LOCK_TIME` = 172800 (2 days) — always read it, never hardcode.
    name: 'lockTime',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'claimWithdraw',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [{ type: 'uint256', name: 'index' }],
    outputs: [{ type: 'uint256' }],
  },
] as const

/** wBETH token — queue entry point. Identical signature on both chains. */
export const BinanceRequestWithdrawAbi = [
  {
    name: 'requestWithdrawEth',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [{ type: 'uint256', name: 'wbethAmount' }],
    outputs: [],
  },
] as const
